<div ngModelGroup="activityInputs">
  <div *ngIf="impacts" id="hideComponentDiv" class="form-group row">
    <div class="col-md-12">
      <!-- Column header -->
      <div class="form-group row">
        <div class="col-md-12">
          <h6>{{ totalHeader }}</h6>
        </div>
      </div>

      <div class="form-group row">
        <div class="col-md-12">
          <p-accordion [multiple]="true">
            <hb-commercial-impact-item [isReadOnly]="isReadOnly" [form]="form" [isProduction]="true"
              [itemType]="commercialImpactItemType.ProductionStream"></hb-commercial-impact-item>
            <hb-commercial-impact-item [isReadOnly]="isReadOnly" [form]="form" [isProduction]="false"
              [itemType]="commercialImpactItemType.Labor"></hb-commercial-impact-item>
            <hb-commercial-impact-item [isReadOnly]="isReadOnly" [form]="form" [isProduction]="false"
              [itemType]="commercialImpactItemType.Material"></hb-commercial-impact-item>
            <hb-commercial-impact-item [isReadOnly]="isReadOnly" [form]="form" [isProduction]="false"
              [itemType]="commercialImpactItemType.Other"></hb-commercial-impact-item>
          </p-accordion>
        </div>
      </div>

      <!-- Totals -->
      <div class="form-group row">
        <div class="col-md-12">
          <h6>{{'CommercialImpacts.Total' | i18next: {value : calculateCurrentTotal()} }}</h6>
        </div>
      </div>

    </div>
  </div>
</div>
